import styled from 'styled-components'
import { Wrapper as StyledModalWarningWrapper } from 'modules/workspace/components/ModalWarning/ModalWarning.styles'

export const StyledDraftsWarningContainer = styled.div`
  /* Overwrite the default margin-top of the ModalWarning component */
  ${StyledModalWarningWrapper} {
    margin-top: 24px;
  }

  p {
    padding: 0;
  }
`
